$('.slider-wrapper').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    focusOnSelect: true,
    appendDots: $('.slider-nav'),
    nextArrow: '<button type="button" class="slick-next"></button>',
    prevArrow: '<button type="button" class="slick-prev"></button>',
    touchMove: false,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        }],
});

$('.tour-slider-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    appendDots: $('.slider-nav'),
    nextArrow: '<button type="button" class="slick-next"></button>',
    prevArrow: '<button type="button" class="slick-prev"></button>',
});
$('.post-sidebar__share-block-subscibe_icon').click(function () {
    if (this.hash !== "") {
        var hash = this.hash;
        $('html, body').animate(
            { scrollTop: $(hash).offset().top }, 800);
    }
})


// WEBPACK FOOTER //
// ./scripts/modules/single-post.js